module.exports = __webpack_public_path__ + "static/media/hybrid-cloud.8ff7f1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hybrid-cloud.png
// module id = 1236
// module chunks = 49